import { IconProps } from '../types';
import Theme from '../../../components-library/Theme';
import classnames from 'classnames';

export default function ClockIcon({ className, color }: IconProps) {
  return (
    <svg
      className={classnames('h-4 w-4', className)}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25738_663)">
        <circle cx="12" cy="12.5" r="11.375" stroke={color ?? Theme.color.gray['100']} strokeWidth="2.0" />
        <path
          d="M12 6V13.5L17 11.5"
          stroke={color ?? Theme.color.gray['100']}
          strokeWidth="2.0"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25738_663">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
